module.exports = __webpack_public_path__ + "img/pampa.8c6a4a67.png";